import RequestEditModal from '@/components/refundDetail/RequestEditModal';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import ICON_LIST from '@/assets/refund/icon_list.png';
import EditListModal from '@/components/refundDetail/EditListModal';
import { useQuery } from 'react-query';
import { fetchExcelData } from '@/api/refund';
import { IExcelData } from '@/types/refund';

type Props = {
  requestType: null | 'COMPLETED' | 'PENDING' | 'REJECTED';
  refundHistoryStatus: string;
  refundIndex: number;
  touristIndex: number;
  requirementId: number;
};

function RequestButton({
  requestType,
  refundHistoryStatus,
  refundIndex,
  touristIndex,
  requirementId,
}: Props) {
  const [isOpenRequestModal, setIsOpenRequestModal] = useState(false);
  const [isOpenEditListModal, setIsOpenEditListModal] = useState(false);

  const buttonLabel = () => {
    if (refundHistoryStatus === 'CANCEL') {
      return '취소 완료';
    }

    switch (requestType) {
      case 'PENDING':
        return '수정 대기중..';
      default:
        return '수정 요청';
    }
  };

  const onOpenRequestModal = () => {
    if (requestType !== 'PENDING') {
      setIsOpenRequestModal(true);
    }
  };

  const { data } = useQuery(
    ['refundDetail'],
    () =>
      fetchExcelData({
        touristIndex,
        refundIndex,
      }),
    {
      enabled: isOpenRequestModal,
    },
  );
  return (
    <>
      {refundHistoryStatus !== 'CANCEL' && (
        <StyledButton
          requestType={requestType}
          refundHistoryStatus={refundHistoryStatus}
          onClick={onOpenRequestModal}
          disabled={
            requestType === 'PENDING' || refundHistoryStatus === 'CANCEL'
          }
        >
          {buttonLabel()}
        </StyledButton>
      )}
      {(requestType === 'COMPLETED' || requestType === 'REJECTED') &&
        refundHistoryStatus !== 'CANCEL' && (
          <ListButton onClick={() => setIsOpenEditListModal(true)}>
            <img src={ICON_LIST} alt='' width={16} />
          </ListButton>
        )}

      {data && isOpenRequestModal && (
        <RequestEditModal
          isOpen={isOpenRequestModal}
          onClose={() => setIsOpenRequestModal(false)}
          data={data as IExcelData[]}
          refundHistoryStatus={refundHistoryStatus}
          chatId={requirementId}
        />
      )}
      {isOpenEditListModal && (
        <EditListModal
          isOpen={isOpenEditListModal}
          onClose={() => setIsOpenEditListModal(false)}
          refundId={refundIndex}
          requirementId={requirementId}
        />
      )}
    </>
  );
}

const StyledButton = styled.button<{
  requestType: null | 'COMPLETED' | 'PENDING' | 'REJECTED';
  refundHistoryStatus: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 120px;
  border: 1px solid;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  width: 96px;
  height: 32px;
  white-space: nowrap;

  &:not(:disabled):hover {
    border-color: #a7c4fb;
    background-color: #d3e2fd;
  }

  ${({ requestType, refundHistoryStatus }) =>
    refundHistoryStatus === 'CANCEL'
      ? css`
          position: relative;
          color: #cbccce;
          border-color: transparent;
          background-color: #fafafa;
          &::after {
            position: absolute;
            top: -1px;
            right: -1px;
            content: '';
            width: 3px;
            height: 3px;
            border-radius: 10px;
            background-color: #ff2d55;
          }
        `
      : requestType === 'COMPLETED' || requestType === 'REJECTED'
      ? css`
          width: 64px;
          white-space: nowrap;
          color: #80848a;
          border-color: #e5e6e8;
          background-color: #fafafa;
        `
      : requestType === 'PENDING'
      ? css`
          color: #7ca7fa;
          border-color: #f4f8ff;
          background-color: #f4f8ff;
        `
      : css`
          white-space: nowrap;
          color: #5f6165;
          border-color: #e5e6e8;
          background-color: #fafafa;
        `}
`;

const ListButton = styled.button`
  margin-left: 5px;
  padding: 3px 0 0 7px;
  display: flex;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  border: 1px solid #e5e6e8;
  background-color: #fafafa;

  &:not(:disabled):hover {
    border-color: #a7c4fb;
    background-color: #d3e2fd;
  }
`;

export default RequestButton;
